import './Modal.scss';

interface ModalProps {
	name: string;
	handleClose: () => void;
	children: string;
};

const Modal = ({name, handleClose, children}: ModalProps) => {

	return (
		<div className="modal-backdrop">
			<div className="modal">
				<div className="modal-body">
					{ children }
				</div>

				{/* <button className="close-btn" onClick={()=> handleClose()}>Close</button> */}
			</div>
		</div>
	);
};

export default Modal;